import { render, staticRenderFns } from "./GatTab.vue?vue&type=template&id=86eb60ee&"
import script from "./GatTab.vue?vue&type=script&lang=js&"
export * from "./GatTab.vue?vue&type=script&lang=js&"
import style0 from "./GatTab.vue?vue&type=style&index=0&id=86eb60ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports